<template>
  <div class="location-search-page">
    <div class="location_header">
      <h4>Pick your Current Location</h4>
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path
            fill="#0b539d"
            d="M9-15.094A3.094,3.094,0,0,0,5.906-12,3.094,3.094,0,0,0,9-8.906,3.094,3.094,0,0,0,12.094-12,3.094,3.094,0,0,0,9-15.094Zm0,4.5A1.408,1.408,0,0,1,7.594-12,1.408,1.408,0,0,1,9-13.406,1.408,1.408,0,0,1,10.406-12,1.408,1.408,0,0,1,9-10.594Zm8.438-2.25H15.692a6.745,6.745,0,0,0-5.848-5.848v-1.746A.562.562,0,0,0,9.281-21H8.719a.562.562,0,0,0-.562.563v1.746a6.745,6.745,0,0,0-5.848,5.848H.563A.562.562,0,0,0,0-12.281v.563a.562.562,0,0,0,.563.563H2.308A6.745,6.745,0,0,0,8.156-5.308v1.746A.562.562,0,0,0,8.719-3h.563a.562.562,0,0,0,.563-.562V-5.308a6.745,6.745,0,0,0,5.848-5.848h1.746A.562.562,0,0,0,18-11.719v-.562A.562.562,0,0,0,17.438-12.844ZM9-6.938A5.068,5.068,0,0,1,3.938-12,5.068,5.068,0,0,1,9-17.062,5.068,5.068,0,0,1,14.063-12,5.068,5.068,0,0,1,9-6.938Z"
            transform="translate(0 21)"
          />
        </svg>
      </span>
    </div>

    <div class="location-search">
      <div class="search-field">
        <input
          type="text"
          v-model="searchLocations"
          @input="handleEvent($event)"
          placeholder="Search..."
        />
        <img src="../assets/images/cross.svg" @click="close()" />
      </div>

      <ul>
        <li v-for="(items, index) in getLocation" :key="index" @click="getlocationitem(items)">
          <p>{{items.description}}</p>
          <img src="../assets/images/ic_map_location.svg" />
        </li>
        <!-- <li>
          <p>Delhi Airport, New Delhi, Delhi</p>
          <img src="../assets/images/ic_map_location.svg">
        </li>-->
      </ul>
    </div>
    <div class="turn-on-location-btn">
      <span class="loct-turn-on-btn" @click="getlocationOn()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path
            fill="#fff"
            d="M9-15.094A3.094,3.094,0,0,0,5.906-12,3.094,3.094,0,0,0,9-8.906,3.094,3.094,0,0,0,12.094-12,3.094,3.094,0,0,0,9-15.094Zm0,4.5A1.408,1.408,0,0,1,7.594-12,1.408,1.408,0,0,1,9-13.406,1.408,1.408,0,0,1,10.406-12,1.408,1.408,0,0,1,9-10.594Zm8.438-2.25H15.692a6.745,6.745,0,0,0-5.848-5.848v-1.746A.562.562,0,0,0,9.281-21H8.719a.562.562,0,0,0-.562.563v1.746a6.745,6.745,0,0,0-5.848,5.848H.563A.562.562,0,0,0,0-12.281v.563a.562.562,0,0,0,.563.563H2.308A6.745,6.745,0,0,0,8.156-5.308v1.746A.562.562,0,0,0,8.719-3h.563a.562.562,0,0,0,.563-.562V-5.308a6.745,6.745,0,0,0,5.848-5.848h1.746A.562.562,0,0,0,18-11.719v-.562A.562.562,0,0,0,17.438-12.844ZM9-6.938A5.068,5.068,0,0,1,3.938-12,5.068,5.068,0,0,1,9-17.062,5.068,5.068,0,0,1,14.063-12,5.068,5.068,0,0,1,9-6.938Z"
            transform="translate(0 21)"
          />
        </svg>
        <span>Turn on Location</span>
      </span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueCookie from "vue-cookie";
import { toaster } from "../utils/helper";
import { mapMutations } from "vuex";
import ApiCaller from "./../utils/apicaller";
import axios from "axios";
Vue.use(VueCookie);
export default {
  name: "Location",
  components: {},
  data() {
    return {
      searchLocations: "",
      getLocation: [],
      latLong: {},
      lat: "",
      long: "",
    };
  },
  methods: {
    handleEvent(event) {
      console.log("################", event.target.value);
      // axios
      //   .get(
      //     `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${event.target.value}&key=AIzaSyDQQbGL9oTLjM2nMNDqJDITRp56op7QM80&sessiontoken=1234567890`
      //   )
      //   .then(response => {
      //     console.log(response);
      //     this.getLocation = response.data.predictions;
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //   });
    },
    // getlocationitem(items) {
    //   console.log("$$$$$data", items);
    //   this.searchLocations = items.description;
    //   this.getLocation = [];
    // },
    close() {
      this.searchLocations = "";
      this.getLocation = [];
    },
    // getlocationOn() {
    //   let lat="", long=""
    //   if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(position => {
    //       console.log("=position=", position);
    //   console.log("lan&long", position.coords.coordinates.latitude)
           
    //     });
    //   } else {
    //     alert("Sorry, browser does not support geolocation!");
    //   }
    // }
  },
  created(){
  },
  computed: {},
  mounted() {
  }
};
</script>
